import { Pipe, PipeTransform } from '@angular/core';

import { LoanToValue } from '@ap/ap-interface-apix-rs-hypotheken-renteoverzicht';

@Pipe({
    name: 'loanToValuePipe',
    standalone: true
})
export class LoanToValuePipe implements PipeTransform {
    transform(loanToValue: LoanToValue): string {
        switch (loanToValue) {
            case LoanToValue.NHG:
                return this.getContentString('nhg');
            case LoanToValue.FORTY:
                return this.getContentString('forty');
            case LoanToValue.FIFTY:
                return this.getContentString('fifty');
            case LoanToValue.SIXTY:
                return this.getContentString('sixty');
            case LoanToValue.SEVENTY:
                return this.getContentString('seventy');
            case LoanToValue.EIGHTY:
                return this.getContentString('eighty');
            case LoanToValue.NINETY:
                return this.getContentString('ninety');
            case LoanToValue.NINETY_FIVE:
                return this.getContentString('ninety-five');
            case LoanToValue.HUNDRED:
                return this.getContentString('hundred');
            case LoanToValue.HUNDRED_AND_SIX:
                return this.getContentString('hundred-and-six');
            case LoanToValue.HUNDRED_AND_SIX_PLUS:
                return this.getContentString('hundred-and-six-plus');
            default:
                return this.getContentString('nhg-ninety');
        }
    }

    private getContentString(loanToValue: string): string {
        return `${loanToValue}.loan-to-value.option`;
    }
}
